/* istanbul ignore file */
export var GeoMessageSenderId;
(function (GeoMessageSenderId) {
    GeoMessageSenderId["Sport"] = "Sport";
    GeoMessageSenderId["Casino"] = "Casino";
})(GeoMessageSenderId || (GeoMessageSenderId = {}));
//# sourceMappingURL=GeoSenders.js.map